
declare const appConfigs: {
    readonly environment: string;
    readonly isLocal: boolean;
    readonly PIERHIPPLAapiUrl: string;
    readonly PIERHIPPAKapiUrl: string;
    readonly PIERHIPPNVapiUrl: string;
    readonly PIERHIPPALapiUrl: string;
    readonly PIERHIPPARapiUrl: string;
    readonly PIERHIPPNCapiUrl: string;
    readonly PIERHIBICOapiUrl: string;
    readonly PIERHIPPGAapiUrl: string;
    readonly PIERCHIPRAGAapiUrl: string;
    readonly PIERHIPPFLapiUrl: string;
    readonly PIERHIPPWVapiUrl: string;
    readonly PIERHIPPDEMOapiUrl: string;
    readonly validateAddresses: boolean;
    readonly smartyKey: string;
};
// copies the global variabel and deletes it
export const config = structuredClone(appConfigs);
const _window = window as any;
if (_window['appConfigs']) {
  delete _window['appConfigs'];
}
